import React from "react";
import { Link } from "react-router-dom";
import {
  AiFillFilePdf,
  AiFillSchedule,
  AiFillSafetyCertificate,
} from "react-icons/ai";
import { FaPeopleArrows } from "react-icons/fa";

const CoursesIntro = ({
  intro,
  des,
  instructorName,
  instructorTitle,
  instructorImg,
  classTitle,
  classNo,
  langClubTitle,
  langClubNo,
  debate,
  support,
  supportTitle,
  bg,
}) => {
  return (
    <div>
      <div className="w-full bg-darkPink text-white text-center md:text-left py-10 px-6 flex gap-8 rounded-lg">
        <div className="w-full md:text-left py-10 px-6 flex flex-col gap-8 rounded-lg">
          <div className="flex flex-col gap-4">
            <h2 className="font-titleFont text-3xl md:text-4xl font-semibold">
              {intro}
            </h2>
            <p className="font-bodyFont w-full lg:w-[600px] text-[14px] md:text-[16px] tracking-wide ">
              {des}
            </p>
          </div>
          <div>
            <h3 className="font-banglaFont text-xl md:text-2xl font-semibold mb-1">
              Meet Your Instructor
            </h3>
            <div className="flex flex-col md:flex-row items-center gap-2 md:gap-6">
              <img
                className="w-24 h-24 rounded-full object-cover"
                src={instructorImg}
                alt="MD Nayeem Hossain"
              />
              <ul className="font-bodyFont text-[14px] text-center md:text-left md:text-[16px]">
                <li className="font-semibold text-lg">{instructorName}</li>
                <li>{instructorTitle}</li>
              </ul>
            </div>
          </div>
          <div>
            <Link to="/admission">
              <button className="relative w-52 text-lg font-semibold uppercase font-titleFont tracking-[2px] border py-3 border-gray-800 overflow-hidden group bg-white hover:bg-primeColor hover:text-white duration-300 text-primeColor rounded-md">
                Enroll Now
              </button>
            </Link>
          </div>
        </div>
        <div className="hidden xl:flex justify-center items-center pr-10">
          <img
            className="w-full object-cover scale-125"
            src={bg}
            alt="spokenEnglishBg"
          />
        </div>
      </div>
      {/* ============================================================= */}
      <div className="max-w-screen-2xl mx-auto grid grid-cols-1 md:grid-cols-2 place-items-center lg:grid-cols-3 xl:grid-cols-4 gap-6 px-4 py-10">
        <div className="w-[250px] h-full border rounded-md shadow-xl hover:shadow-none transition-hover duration-300 shadow-shadowOne border-primeColor flex items-center justify-center gap-4 text-lg py-4">
          <span className="text-white text-2xl w-10 h-10 rounded-full bg-primeColor flex items-center justify-center">
            <AiFillSchedule />
          </span>
          <p className="text-lg uppercase font-semibold">
            <span className="text-primeColor font-bold text-xl mr-1">
              {classNo}
            </span>
            {classTitle}
          </p>
        </div>
        <div className="w-[250px] h-full border rounded-md shadow-xl hover:shadow-none transition-hover duration-300 shadow-shadowOne border-primeColor flex items-center justify-center gap-4 text-lg py-4">
          <span className="text-white text-2xl w-10 h-10 rounded-full bg-primeColor flex items-center justify-center">
            <AiFillFilePdf />
          </span>
          <p className="text-lg uppercase font-semibold">
            <span className="text-primeColor font-bold text-xl mr-1">
              {langClubNo}
            </span>
            {langClubTitle}
          </p>
        </div>
        <div className="w-[250px] h-full border rounded-md shadow-xl hover:shadow-none transition-hover duration-300 shadow-shadowOne border-primeColor flex items-center justify-center gap-4 text-lg py-4">
          <span className="text-white text-2xl w-10 h-10 rounded-full bg-primeColor flex items-center justify-center">
            <FaPeopleArrows />
          </span>
          <p className="text-lg uppercase font-semibold">
            <span className="text-primeColor font-bold text-xl"></span>
            {debate}
          </p>
        </div>

        <div className="w-[250px] h-full border rounded-md shadow-xl hover:shadow-none transition-hover duration-300 shadow-shadowOne border-primeColor flex items-center justify-center gap-4 text-lg py-4">
          <span className="text-white text-2xl w-10 h-10 rounded-full bg-primeColor flex items-center justify-center">
            <AiFillSafetyCertificate />
          </span>
          <p className="text-lg uppercase font-semibold">
            <span className="text-primeColor font-bold text-xl mr-1">
              {support}
            </span>
            {supportTitle}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CoursesIntro;
